import { honoreesModalSlidersMap } from './_modal_slider.js';

let scrollPosition = 0;

const body = document.body;
const common_modal_item = document.querySelectorAll('.common_modal_item');
const common_modal = document.querySelectorAll('.common_modal');
const common_modal_close = document.querySelectorAll('.common_modal_close');
const common_modal_inner = document.querySelectorAll('.common_modal_inner');
const common_modal_inertElement = [
  document.querySelector("header"),
  document.querySelector("main"),
  document.querySelector("footer"),
];

export function modalClose() {
  const now_open = document.querySelector('.common_modal[aria-hidden="false"]');
  if (!now_open) return;
  const now_open_id = now_open.getAttribute('id');

  common_modal.forEach((el) => el.setAttribute('aria-hidden', 'true'));
  common_modal_item.forEach((el) => el.setAttribute('aria-expanded', 'false'));
  body.classList.remove('is-noscroll');
  common_modal_inertElement.forEach((inertEl) => inertEl.removeAttribute('inert'));
  document.querySelector('[aria-controls="' + now_open_id + '"]')?.focus();

  body.style.top = '';
  window.scrollTo(0, scrollPosition);
}

function modalOpen(el) {
  scrollPosition = window.scrollY;
  body.style.top = `-${scrollPosition}px`;
  const target_id = el.getAttribute('aria-controls');
  const target = document.querySelector('#' + target_id);
  target.setAttribute('aria-hidden', 'false');
  el.setAttribute('aria-expanded', 'true');
  body.classList.add('is-noscroll');
  common_modal_inertElement.forEach((inertEl) => inertEl.setAttribute('inert', ''));

  const slideIndex = parseInt(el.dataset.slideIndex, 10);
  const swiper = honoreesModalSlidersMap.get(target_id);
  if (swiper && !isNaN(slideIndex)) {
    swiper.slideToLoop(slideIndex); // loop: true の場合 slideToLoop
  }
}

export function modal() {
  common_modal_item.forEach((el) => {
    el.addEventListener('click', () => modalOpen(el));
  });

  common_modal_close.forEach((el) => {
    el.addEventListener('click', modalClose);
  });

  common_modal.forEach((el) => {
    el.addEventListener('click', modalClose);
  });

  common_modal_inner.forEach((el) => {
    el.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  function changeModalClass(wH) {
    common_modal_inner.forEach((el) => {
      if (el.clientHeight > wH) {
        el.classList.add('is-largecontents');
      } else {
        el.classList.remove('is-largecontents');
      }
    });
  }

  let resizeTimer = false;
  let wH = window.innerHeight;
  changeModalClass(wH);

  window.addEventListener('resize', () => {
    if (resizeTimer !== false) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(() => {
      const lastWH = window.innerHeight;
      changeModalClass(lastWH);
    }, 200);
  });
}
